const retagConstants = {
	FETCH_RETAG_REASONS_SUCCESS: 'FETCH_RETAG_REASONS_SUCCESS',
	ADD_RETAG_REASON: 'ADD_RETAG_REASON',
};

export default retagConstants;
